import React from "react";
import { format } from "date-fns";

import styles from "./Notice.module.css";

function Notice(props: any) {
  const {
    title,
    image,
    publishTime,
    vendor,
    synopsis,
    id
  } = props;
  return (
    <div className={styles.item}>
      <a href={`//paimai.jd.com/notice/${id}`} target="_blank">
        <div className={styles.itemhead}>
          <div className={styles.itemname}>
            {title}
          </div>
        </div>
        <div className={styles.itembody}>
          <div className={styles.itempic}>
            <img data-lazy-img="done" src={`//img11.360buyimg.com/imgw/s288x1000_${image}!q80!cc_3x2`} />
          </div>
          <div className={styles.itemcontent}>
            <div className={styles.itemsynopsis}>
              <p>{synopsis}</p>
            </div>
            <div className={styles.iteminfo}>
              <span>送拍机构：{vendor}</span>
              <span>发布时间：{format(publishTime,"yyyy-MM-dd HH:mm")}</span>
            </div>
          </div>
        </div>
      </a>
    </div>

  );
}

export default Notice;
